export const LOCATIONS = [
  {
    slug: "canberra",
    name: "Canberra",
    region: "Australian Capital Territory",
    card: "Our home base — in-person advice from Marcus Clarke Street, across the ACT.",
    image:
      "https://images.unsplash.com/photo-1766397218059-60b57f20b211?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxjYW5iZXJyYSUyMGxhbmRzY2FwZSUyMG1vcm5pbmd8ZW58MHx8fHwxNzg3OTA5NzgyfDA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Mist rolling over the hills surrounding Canberra at first light",
    imageCaption: "Our home — the Canberra region at first light",
    subcopy:
      "Our home. From our office on Marcus Clarke Street we advise public servants, defence families and business owners across the ACT — with particular depth in Commonwealth super schemes and the retirement questions that come with them.",
    profiles: [
      {
        title: "APS & defence super",
        body: "Deep experience with PSS, CSS and PSSap — contribution strategy, preservation-age timing, and making the most of your scheme before you finish.",
      },
      {
        title: "Retiring in the ACT",
        body: "Turning super, savings and the age pension into a retirement income you can actually plan around.",
      },
      {
        title: "Canberra business owners",
        body: "Succession, structures and building personal wealth beyond the business.",
      },
    ],
    note: "Meet us in person at 121 Marcus Clarke Street, Canberra — or by secure video, whatever suits.",
    seoTitle: "Independent Financial Adviser Canberra | NUA Private Wealth — Fee-for-Service Advice",
    seoDescription:
      "Truly independent, fee-for-service financial advice in Canberra ACT. No commissions, no asset-based fees, no product promotion. APS super, retirement planning, investment and aged care advice.",
  },
  {
    slug: "sydney",
    name: "Sydney",
    region: "New South Wales",
    card: "Full service advice in CBD office or by secure video call, for professionals, families and business owners.",
    image: "https://images.unsplash.com/photo-1531033056439-63578c0d9f22?q=85&w=1600&auto=format&fit=crop",
    imageAlt: "The Sydney Harbour Bridge",
    imageCaption: "Sydney Harbour Bridge — advised from our CBD office",
    subcopy:
      "We advise clients across Sydney from our CBD serviced office, with the same fixed-fee, no-product agenda. No city premium, and no percentage skimmed from your portfolio.",
    profiles: [
      {
        title: "Executives & professionals",
        body: "Equity compensation, surplus cash flow and tax-effective investing for demanding careers.",
      },
      {
        title: "Pre-retirees",
        body: "Structuring the decade before retirement while you're still earning — super, debt and investments working together.",
      },
      {
        title: "Business owners",
        body: "Extracting value from the business into personal wealth, tax-effectively.",
      },
    ],
    note: "Meeting options — secure video, serviced offices in the Sydney CBD (subject to availability), or home visits.",
    seoTitle: "Independent Financial Adviser Sydney | NUA Private Wealth — Fee-for-Service Advice",
    seoDescription:
      "Truly independent, fee-for-service financial advice for Sydney. No commissions, no asset-based fees, no product promotion. Investment strategy, retirement planning and super advice by secure video.",
  },
  {
    slug: "nsw-south-coast",
    name: "NSW South Coast",
    region: "Wollongong to Eden, New South Wales",
    card: "Sea-change retirees and coastal communities across regional New South Wales, from Wollongong to Eden.",
    image: "https://images.unsplash.com/photo-1702596301369-cea803a54c57?q=85&w=1600&auto=format&fit=crop",
    imageAlt: "The coastline of the NSW South Coast",
    imageCaption: "The South Coast — from Wollongong to Eden",
    subcopy:
      "From Wollongong to Eden and the villages between, we work with sea-changers, retirees and local families across the South Coast — mostly by video, with visits scheduled through the year.",
    profiles: [
      {
        title: "Sea-change retirees",
        body: "Making the move from Sydney or Canberra stack up — sale proceeds, stamp duty trade-offs and a retirement income that lasts.",
      },
      {
        title: "Aged care decisions",
        body: "Clear-eyed guidance on RADs, means-tested fees and the family conversations that come with them.",
      },
      {
        title: "Small business & tourism operators",
        body: "Personal wealth that isn't hostage to the season — super, insurance and succession for owner-operators.",
      },
    ],
    note: "Meeting options — secure video, serviced offices along the coast (subject to availability), or home visits.",
    seoTitle: "Independent Financial Adviser NSW South Coast & New South Wales | NUA Private Wealth",
    seoDescription:
      "Truly independent, fee-for-service financial adviser for the NSW South Coast and regional New South Wales — Wollongong, Nowra, Batemans Bay to Eden. No commissions or asset-based fees. Sea-change retirement, aged care and small business advice across NSW.",
    towns: [
      {
        name: "Mollymook",
        blurb:
          "Beachside professionals and semi-retired sea-changers who still earn from the coast. We help you keep investments, income and superannuation working while you enjoy the Mollymook and Ulladulla lifestyle you moved here for.",
        image:
          "https://images.pexels.com/photos/6775357/pexels-photo-6775357.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        imageAlt: "Aerial view of Mollymook Beach, NSW, at sunrise",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Mollymook+NSW",
      },
      {
        name: "Batemans Bay",
        blurb:
          "The commercial heart of the Eurobodalla. We advise Batemans Bay business owners and tourism operators on cash flow, structures, succession and building genuine personal wealth beyond the business.",
        image:
          "https://images.pexels.com/photos/38186732/pexels-photo-38186732.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        imageAlt: "Yachts moored in Batemans Bay at first light",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Batemans+Bay+NSW",
      },
      {
        name: "Narooma",
        blurb:
          "A tree-change and retirement haven on the Wagonga Inlet. We guide Narooma retirees and downsizers on turning the sale of a city home into a lasting, tax-effective income — and on aged care when the time comes.",
        image:
          "https://images.pexels.com/photos/5657437/pexels-photo-5657437.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        imageAlt: "The rocky coastline and inlet at Narooma, NSW",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Narooma+NSW",
      },
      {
        name: "Merimbula",
        blurb:
          "The Sapphire Coast's retirement-lifestyle capital. We help Merimbula retirees turn super, savings and a home sale into an income that lasts, with clear age-pension planning and estate advice.",
        image:
          "https://images.pexels.com/photos/355209/pexels-photo-355209.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        imageAlt: "A timber jetty reaching over calm water at sunset near Merimbula",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Merimbula+NSW",
      },
      {
        name: "Eden",
        blurb:
          "A working port town with deep community roots. We help Eden fishing families, tradespeople and small businesses build wealth that stays resilient through the seasons, with the right insurance and super in place.",
        image:
          "https://images.pexels.com/photos/29793988/pexels-photo-29793988.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        imageAlt: "Fishing boats moored in a calm natural harbour at Eden",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Eden+NSW",
      },
    ],
  },
  {
    slug: "albury",
    name: "Albury",
    region: "Albury–Wodonga, NSW–VIC border",
    card: "Border-region families, farmers and business owners across Albury–Wodonga.",
    image: "https://images.unsplash.com/photo-1590368694986-3faad6cf537a?q=85&w=1600&auto=format&fit=crop",
    imageAlt: "The Murray River region near Albury",
    imageCaption: "The Murray region — Albury–Wodonga",
    subcopy:
      "On the border of NSW and Victoria, we advise Albury–Wodonga families, farmers and business owners. Cross-border questions welcome — plain-English answers guaranteed.",
    profiles: [
      {
        title: "Farming families",
        body: "Succession between generations, off-farm wealth and retiring from the land without losing it.",
      },
      {
        title: "Cross-border households",
        body: "Living in Albury–Wodonga means two states' rules — super, insurance and estate considerations handled in one plan.",
      },
      {
        title: "Regional professionals",
        body: "Building serious wealth without city-sized fees or percentage-based advice costs.",
      },
    ],
    note: "Meeting options — secure video, serviced offices in Albury–Wodonga (subject to availability), or home visits.",
    seoTitle: "Independent Financial Adviser Albury | NUA Private Wealth — Fee-for-Service Advice",
    seoDescription:
      "Truly independent, fee-for-service financial advice in Albury–Wodonga. No commissions, no asset-based fees. Farm succession, retirement planning and investment advice for the border region.",
  },
];

export const CHARTER_CHIPS = [
  "No vertical integration",
  "No asset-based fees",
  "No product promotion",
  "Personal advice only",
];
